import type { AppState } from 'state/state.model';

function getSettlementDateCalendars(state: AppState) {
  return state.settlementDateCalendars;
}

export function isUnknownSettlementDateCalendar(state: AppState, currency: string): boolean {
  const settlementDateCalendarCurrencies = Object.keys(getSettlementDateCalendars(state));
  return !settlementDateCalendarCurrencies.includes(currency);
}
